/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
import {
  ChartContainer,
  CloseButton,
  ContainerCard,
  ContainerForm,
  ContainerButtonAndInput,
  DetailsContainer,
  HeaderContainer,
  LegendChart,
  LegendChartContainer,
  LegendChartText,
  LegendChartText1,
  LegendChartText2,
  MainContainer,
  MetaGeralContainer,
  BlurSubtitleMetaGeral,
  LabelInputForm,
  Input,
  SubTitleForm,
  Container,
  TitleContainerMobile,
  TitleTextMobile,
  DailyGoalsTitleContainer,
  BlurredChartContainer,
  BlurTitle,
  BlurSubtitle,
  BlurChartContainer,
  BlurMainContainer,
  HeaderModalContainer,
  TitleModalContainer,
  ButtonModalContainer,
  HeaderModalIconContainer,
  CustomInput,
  ModalSetGoalsContainer,
  SetGoalsModalInput,
  ModalButtonsContainer,
  ButtonAddAndInputModalContainer,
  CalendarContainer,
  MessageAddOrEditGoalContainer,
  MessageAddOrEditGoalText,
  SetGoalsQuantityContainerModal,
  SetGoalsQuantityContainerTextModal,
  DataSetGoalsQuantityContainerModal,
  DataSetGoalsQuantityTextModal,
  IconGarbageContainer,
  LoadingSpinner,
  TitleTextGeneralGoals,
  SubTextContainer,
  TitleTextDailyGoals,
  MainDailyGoalsContainer,
  SetGoalButtonContainer,
} from './styles'
import {
  closeButtonIcon,
  ticketIcon,
  goalsIcon,
  percentageIcon,
  exclamationMark,
  garbage,
} from '../Icon/iconsImport'
import * as style from './style.module.css'
import { ReactNode, useEffect, useState, useRef } from 'react'
import {
  DashboardManagerGoalsBarChart,
  Modal,
  DashboardhLargeButton,
  DashboardhMediumButton,
  DefaultCardDashboard,
  Icon,
} from 'bd-web-components'
import { useParams } from 'react-router-dom'
// @ts-ignore
import { toast } from 'react-toastify'
import { IconProducer } from '../Icon/index'
import { SmallCard } from '../SmallCard'
import CustomButton from '../CustomButton'
import DatePicker from 'react-datepicker'
import { CustomModal } from '../CustomModal'
import { formatDateToPortuguese } from '../../utils/formatDateToPortuguese'
import { useAuth } from '../../hooks/auth'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import { isNumeric } from '../../utils/hasOnlyNumbers'
// @ts-ignore
import { format } from 'date-fns'
import {
  addDailyGoalsRequest,
  deleteDailyGoalRequest,
  DeleteGoalPayloadProps,
  getDailyEventGoals,
  getGeneralEventGoal,
  UpdateGeneralGoalDataProp,
  UpdateGeneralGoalProp,
  updateGeneralGoalRequest,
} from '../../Service/goals'
import {
  mockBlurData,
  mockGoals,
  mockGoalsGeneral,
} from '../../utils/dashMockData'
import ConditionalRenderComponent from '../RenderControl'
import {
  dateShortForNewer,
  inParseDate,
  parseDate,
  removeThisFnWhenCleitonFinishCorrectionOnGoalsDate,
} from '../../utils/dateFormat'
import { getDashColor } from '../../styles'
import {
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'

interface CalendarProps {
  children: ReactNode
}

interface SubtitledCharContainerProps {
  labels: any
  chartData: any
}

const CustomCalendarContainer = ({ children }: CalendarProps) => {
  return (
    <CalendarContainer className="custom-calendar-container">
      {children}
    </CalendarContainer>
  )
}

const SubtitledCharContainer = ({
  labels,
  chartData,
}: SubtitledCharContainerProps) => {
  return (
    <ChartContainer>
      <LegendChartContainer>
        <LegendChart>
          <LegendChartText1>{'Vendas acima da Meta'}</LegendChartText1>
        </LegendChart>
        <LegendChart>
          <LegendChartText2>{'Vendas abaixo da Meta'}</LegendChartText2>
        </LegendChart>
        <LegendChart>
          <LegendChartText>{'Metas'}</LegendChartText>
        </LegendChart>
      </LegendChartContainer>
      <DashboardManagerGoalsBarChart labels={labels} chartData={chartData} />
    </ChartContainer>
  )
}

interface ManagerGoalsCardProps {
  setOverflow: (x: boolean) => void
  startDate: string
  endDate: string
}

const ManagerGoalsCard: React.FC<ManagerGoalsCardProps> = ({
  setOverflow,
  startDate: initialStartDate,
  endDate: initialEndDate,
}) => {
  let listChartDataMetaGoal: any = []
  let listLabelsGoal: any = []
  let listChartDataTickets: any = []
  let notUndefinedId: string = ''

  const authContext = useAuth()
  const { id } = useParams()
  if (id !== undefined) notUndefinedId = id

  const { cookies } = authContext
  const authToken = LOCAL_EXECUTION
    ? process.env.REACT_APP_LOCAL_EXECUTION_TOKEN
    : cookies.userJWT

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalGoalsOpen, setIsModalGoalsOpen] = useState(false)
  const [goalGeral, setGoalGeral] = useState<string>('')
  const [dailyGoalState, setDailyGoalState] = useState<string>('')

  const [startDate, setStartDate] = useState<any>(null)
  const [endDate, setEndDate] = useState<any>(null)
  const [startDateChange, setStartDateChange] = useState<Date | null>(null)
  const [endDateChange, setEndDateChange] = useState<Date | null>(null)
  const [isEditingGoal, setIsEditingGoal] = useState(false)
  const [message, setMessage] = useState('')

  const [isLoading, setIsLoading] = useState(false)
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true)

  const [nGeneralGoal, setNGeneralGoal] = useState<any>(mockGoalsGeneral)
  const [nDailyGoals, setNDailyGoals] = useState<any>(mockGoals)
  const [goals, setGoals] = useState<any>([])
  const [update, setUpdate] = useState<any>(true)

  const goalArrRef = useRef(goals)

  useEffect(() => { }, [nGeneralGoal, nDailyGoals, goals])

  useEffect(() => {
    const generalGoalsData = () => {
      return getGeneralEventGoal(
        authToken,
        notUndefinedId,
        initialEndDate,
        initialStartDate
      )
    }
    generalGoalsData().then((requestData) => {
      setNGeneralGoal(requestData)
    })
    const dailyGoalsData = () => {
      return getDailyEventGoals(
        authToken,
        notUndefinedId,
        initialEndDate,
        initialStartDate
      )
    }
    dailyGoalsData().then((requestData) => {
      setNDailyGoals(requestData)
      if (requestData.metas[0] !== undefined) {
        const metasArr = dateShortForNewer(requestData.metas)
        setGoals(metasArr)
      } else {
        setGoals(requestData.metas)
      }
    })
  }, [notUndefinedId, update])

  // MODAL OPEN CONTROL
  const handlerOpenModalAndHideOverflow = (
    setToUpdate: React.Dispatch<React.SetStateAction<boolean>>,
    value: boolean
  ) => {
    goalArrRef.current = JSON.stringify(goals)
    if (value) {
      setToUpdate(value)
      setOverflow(value)
    } else {
      setToUpdate(value)
      setOverflow(value)
    }
  }

  const onRequestClose = () => {
    if (JSON.stringify(goals) !== goalArrRef.current) setUpdate(!update)
    handlerOpenModalAndHideOverflow(setIsModalOpen, false)
    handlerOpenModalAndHideOverflow(setIsModalGoalsOpen, false)
    setIsEditingGoal(false)
  }

  // <X> GENERAL GOAL LOGIC SECTION</X>
  // UPDATE GENERAL EVENT GOAL
  const generalGoalUpdate = () => {
    setIsLoading(true)
    const payload: UpdateGeneralGoalDataProp = {
      eventId: notUndefinedId,
      goal: goalGeral,
    }

    updateGeneralGoalRequest(authToken, payload)
      .then((requestData) => {
        if (requestData) {
          handlerOpenModalAndHideOverflow(setIsModalOpen, false)
          const nGeneral = {
            meta: Number(goalGeral),
            quantidadeVendas: nGeneralGoal.quantidadeVendas,
            percentualMeta:
              (nGeneralGoal.quantidadeVendas / Number(goalGeral)) * 100,
          }
          setNGeneralGoal(nGeneral)
          toast.success('Meta definida com sucesso!')
        } else {
          toast.success('Um erro aconteceu ao definir a meta!')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  // GENERAL GOAL INPUT CONTROL ??
  const blockInvalidChar = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const invalidChars = ['e', 'E', '+', '-']
    if (invalidChars.includes(e.key)) {
      e.preventDefault()
    }
  }

  // <X> DAILY GOALS LOGIC SECTION</X>

  if (nDailyGoals) {
    nDailyGoals?.metas.forEach((data: any) => {
      const dayAndMonth = removeThisFnWhenCleitonFinishCorrectionOnGoalsDate(
        data.dia,
        undefined
      )
      listLabelsGoal.push(dayAndMonth)
      listChartDataMetaGoal.push(data?.meta)

      listChartDataTickets.push(parseInt(data?.quantidadeIngressosVendidos))
    })
  }

  const goalsManager = {
    labels: listLabelsGoal,
    chartData: {
      datasets: [
        {
          label: 'Meta',
          data: listChartDataMetaGoal,
        },
        {
          label: '',
          data: listChartDataTickets,
        },
      ],
    },
  }

  // DAILY DATE PICKER HANDLER
  const handlerCalendarDateChanges = (range: [Date | null, Date | null]) => {
    const [startDate, endDate] = range
    setIsEditingGoal(true)
    setStartDate(startDate)
    setStartDateChange(startDate)
    setEndDate(endDate)
    setEndDateChange(endDate)
  }

  // HANDLE DAILY GOAL INPUT
  const HandlerDailyGoals = (e: any) => {
    setDailyGoalState(e.target.value)
    setMessage(e.target.value)

    // VALIDATE INPUT
    const hasOnlyNumeric = isNumeric(e.target.value)
    const disable = e.target.value === '' || Number(e.target.value) === 0
    const dobleValidation = disable || !hasOnlyNumeric
    setIsSaveButtonDisabled(dobleValidation)
  }

  // ADD NEW DAILY GOALS
  const handleUpdateNewDailyGoal = () => {
    if (dailyGoalState) {
      setIsLoading(true)

      const startDate: any = parseDate(startDateChange)
      const endDate: any = parseDate(endDateChange)

      if (!startDate && !endDate) {
        throw new Error(
          'Datas inválidas. Certifique-se de que estão no formato DD/MM/YYYY.'
        )
      }

      const intervaloDeDatas: any[] = []
      intervaloDeDatas.push(startDate)

      if (endDateChange) {
        let dataAtual = new Date(startDateChange as Date)
        while (dataAtual < endDateChange) {
          dataAtual = new Date(dataAtual.setDate(dataAtual.getDate() + 1))
          intervaloDeDatas.push(format(dataAtual, 'dd/MM/yyyy'))
        }
      }
      setMessage('')
      const payload: any = {
        eventId: notUndefinedId,
        goal: dailyGoalState,
        datas: intervaloDeDatas,
      }
      addDailyGoalsRequest(authToken, payload)
        .then((response) => {
          if (response.status) {
            setIsEditingGoal(false)
            toast.success('Meta definida com sucesso!')
            const momentGoals = goals
            intervaloDeDatas.forEach((data) => {
              momentGoals.push({
                dia: inParseDate(data),
                quantidadeIngressosVendidos: 0,
                meta: dailyGoalState,
                percentualMeta: 0,
              })
            })
            const newGoals = dateShortForNewer(momentGoals)
            setGoals(newGoals)
            setUpdate(!update)
            handlerOpenModalAndHideOverflow(setIsModalGoalsOpen, false)
          } else {
            toast.error(response.msg)
          }
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      toast.error('Insira a meta desejada!')
    }
  }

  // DELETE ON DAY GOAL
  const deleteDailyGoal = (dateToDelete: string) => {
    const datesFormat = removeThisFnWhenCleitonFinishCorrectionOnGoalsDate(
      dateToDelete,
      'year'
    )
    const updatedGoals = goals.filter((goal: any) => goal.dia !== dateToDelete)
    setGoals(updatedGoals)
    goalArrRef.current = updatedGoals
    if (dailyGoalState === dateToDelete) {
      setDailyGoalState('')
    }
    const payload: DeleteGoalPayloadProps = {
      data: {
        eventId: notUndefinedId,
        datas: [datesFormat],
      },
    }
    deleteDailyGoalRequest(authToken, payload).then((response) => {
      if (response) {
        toast.success('Meta excluída com sucesso!')
      } else {
        toast.success('Um erro aconteceu ao deletar a meta!')
      }
    })
  }

  // CONTROL COMPONENT RENDER
  const goalsRenderControl =
    nGeneralGoal.isLoading === undefined &&
    nGeneralGoal.isMessage === undefined &&
    nGeneralGoal.isError === undefined
  const dailyGoalsRenderControl =
    nDailyGoals.isLoading === undefined &&
    nDailyGoals.isMessage === undefined &&
    nDailyGoals.isError === undefined
  const percentualMeta =
    nGeneralGoal.percentualMeta === null ? 0 : nGeneralGoal.percentualMeta

  return (
    <Container>
      <TitleContainerMobile>
        <TitleTextMobile>Gerenciados de Metas</TitleTextMobile>
      </TitleContainerMobile>
      <ContainerCard>
        {/* GENERAL GOAL CONTAINER */}
        <DefaultCardDashboard>
          <ConditionalRenderComponent
            isLoading={nGeneralGoal.isLoading === true}
            isMessage={nGeneralGoal.isMessage === true}
            isError={nGeneralGoal.isError === true}
            isRender={goalsRenderControl}
            hasImage={false}
            maxHeight={200}
          >
            <>
              <HeaderContainer>
                {/* MODAL GENERAL GOAL */}
                <Modal isShowing={isModalOpen} onRequestClose={onRequestClose}>
                  <HeaderModalContainer>
                    <HeaderModalIconContainer>
                      <IconProducer src={goalsIcon} />
                    </HeaderModalIconContainer>
                    <TitleModalContainer>
                      <LabelInputForm>Definir Meta Geral</LabelInputForm>
                      <SubTitleForm>
                        Digite abaixo a meta total de ingressos.
                      </SubTitleForm>
                    </TitleModalContainer>
                    <CloseButton onClick={onRequestClose} type="button">
                      <IconProducer src={closeButtonIcon} />
                    </CloseButton>
                  </HeaderModalContainer>
                  <ContainerForm>
                    <SubTitleForm>
                      Defina a Meta Total de vendas de ingressos
                    </SubTitleForm>
                    <ContainerButtonAndInput>
                      <Input
                        type="number"
                        name="goals"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        onKeyDown={blockInvalidChar}
                        className="input-modal"
                        onInput={(e: any) => setGoalGeral(e.target.value)}
                        placeholder="Adicione aqui sua meta"
                      />
                      <ButtonModalContainer>
                        <DashboardhMediumButton
                          onClick={onRequestClose}
                          variant="outlined"
                          borderRadius='100px'
                        >
                          Cancelar
                        </DashboardhMediumButton>
                        <DashboardhMediumButton
                          onClick={generalGoalUpdate}
                          variant="contained"
                          background={getDashColor('SECONDARY_GREEN_07', 'SECONDARY_COLOR')}
                          width="100%"
                          maxWidth="337px"
                          borderRadius='100px'
                        >
                          {isLoading ? <LoadingSpinner /> : 'Salvar Meta'}
                        </DashboardhMediumButton>
                      </ButtonModalContainer>
                    </ContainerButtonAndInput>
                  </ContainerForm>
                </Modal>
                <MetaGeralContainer>
                  <TitleTextGeneralGoals>Meta Geral</TitleTextGeneralGoals>
                  <SubTextContainer>
                    {(nGeneralGoal.meta === undefined ||
                      nGeneralGoal.meta === 0) && (
                        <BlurSubtitleMetaGeral>
                          Para visualizar o dados, por favor defina uma meta geral
                          para esse evento.
                        </BlurSubtitleMetaGeral>
                      )}
                  </SubTextContainer>
                  <SetGoalButtonContainer>
                    <DashboardhMediumButton
                      onClick={() =>
                        handlerOpenModalAndHideOverflow(setIsModalOpen, true)
                      }
                      maxWidth="100%"
                      height="50px"
                      variant="contained"
                      background={getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
                      borderRadius='100px'
                    >
                      Definir Meta
                      <Icon
                        fill={WHITE}
                        iconName={'target'}
                        height={24}
                        width={24}
                        classes=""
                      />
                    </DashboardhMediumButton>
                  </SetGoalButtonContainer>
                </MetaGeralContainer>
              </HeaderContainer>
              <MainContainer>
                <DetailsContainer>
                  <SmallCard
                    icon={<IconProducer src={goalsIcon} />}
                    title="Meta De Vendas"
                    value={Number(nGeneralGoal.meta ?? 0).toLocaleString(
                      'pt-BR'
                    )}
                  />
                  <SmallCard
                    icon={<IconProducer src={ticketIcon} />}
                    title="Quantidade De Vendas"
                    value={Number(
                      nGeneralGoal.quantidadeVendas ?? 0
                    ).toLocaleString('pt-BR')}
                  />
                  <SmallCard
                    icon={<IconProducer src={percentageIcon} />}
                    title="Percentual de Meta"
                    value={`${Number(
                      parseFloat(percentualMeta.toFixed(2)) ?? 0
                    ).toLocaleString('pt-BR')}%`}
                  />
                </DetailsContainer>
              </MainContainer>
            </>
          </ConditionalRenderComponent>

          {/* DAILY GOALS SECTION */}
          <ConditionalRenderComponent
            isLoading={nDailyGoals.isLoading === true}
            isMessage={nDailyGoals.isMessage === true}
            isError={nDailyGoals.isError === true}
            maxHeight={300}
            isRender={dailyGoalsRenderControl}
          >
            <MainDailyGoalsContainer>
              <DailyGoalsTitleContainer>
                <TitleTextDailyGoals>{'Metas Diárias'}</TitleTextDailyGoals>
                {nDailyGoals.metas.length > 0 ? (
                  <SetGoalButtonContainer>
                    <DashboardhMediumButton
                      onClick={() => {
                        // setIsBlurEnabled(true)
                        handlerOpenModalAndHideOverflow(
                          setIsModalGoalsOpen,
                          true
                        )
                      }}
                      maxWidth="100%"
                      height="50px"
                      variant="contained"
                      background={getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
                      borderRadius='100px'
                    >
                      Definir Meta
                      <Icon
                        fill={WHITE}
                        iconName={'target'}
                        height={24}
                        width={24}
                        classes=""
                      />
                    </DashboardhMediumButton>
                  </SetGoalButtonContainer>
                ) : null}
              </DailyGoalsTitleContainer>
              {nDailyGoals.metas.length <= 0 ? (
                <>
                  <BlurChartContainer>
                    <BlurMainContainer>
                      <BlurTitle>{'Gerenciador de Metas'}</BlurTitle>
                      <BlurSubtitle>
                        {
                          'Para visualizar o gráfico, por favor defina uma meta diária de vendas.'
                        }
                      </BlurSubtitle>
                      <DashboardhLargeButton
                        variant="contained"
                        onClick={() =>
                          handlerOpenModalAndHideOverflow(
                            setIsModalGoalsOpen,
                            true
                          )
                        }
                        width="100%"
                        maxWidth="396px"
                        height="60px"
                        background={getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
                        borderRadius="100px"
                      >
                        Definir Meta
                        <Icon
                          fill={WHITE}
                          iconName={'target'}
                          height={24}
                          width={24}
                          classes=""
                        />
                      </DashboardhLargeButton>
                    </BlurMainContainer>
                  </BlurChartContainer>
                  <BlurredChartContainer>
                    <SubtitledCharContainer
                      labels={mockBlurData.labels}
                      chartData={mockBlurData.chartData}
                    />
                  </BlurredChartContainer>
                </>
              ) : (
                <SubtitledCharContainer
                  labels={goalsManager.labels}
                  chartData={goalsManager.chartData}
                />
              )}
              {/* MODAL DE CONTROLE DAS DIARIAS */}
              <CustomModal
                isOpen={isModalGoalsOpen}
                onRequestClose={onRequestClose}
              >
                <HeaderModalContainer>
                  <HeaderModalIconContainer>
                    <IconProducer src={goalsIcon} />
                  </HeaderModalIconContainer>
                  <TitleModalContainer>
                    <LabelInputForm>Metas</LabelInputForm>
                    <SubTitleForm>
                      Selecione as propriedades que deseja ver dentro da tela.
                    </SubTitleForm>
                  </TitleModalContainer>
                  <CloseButton onClick={onRequestClose} type="button">
                    <IconProducer src={closeButtonIcon} />
                  </CloseButton>
                </HeaderModalContainer>
                <ModalSetGoalsContainer>
                  <DatePicker
                    selected={startDate}
                    onChange={handlerCalendarDateChanges}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    open={true}
                    customInput={<CustomInput />}
                    showPopperArrow={false}
                    dateFormat="dd/MM/yyyy"
                    calendarContainer={CustomCalendarContainer}
                    highlightDates={goals.map(
                      (dateString: any) => new Date(dateString.dia)
                    )}
                  />
                  {goals.length > 0 && !isEditingGoal ? (
                    <MessageAddOrEditGoalContainer>
                      <SetGoalsQuantityContainerModal>
                        <SetGoalsQuantityContainerTextModal>
                          Meta definida
                        </SetGoalsQuantityContainerTextModal>
                        <SetGoalsQuantityContainerTextModal>
                          Quantidade
                        </SetGoalsQuantityContainerTextModal>
                      </SetGoalsQuantityContainerModal>
                      {goals.map((goal: any) => (
                        <DataSetGoalsQuantityContainerModal
                          key={`goal-${goal.dia}`}
                        >
                          <DataSetGoalsQuantityTextModal>
                            {formatDateToPortuguese(goal.dia)}
                          </DataSetGoalsQuantityTextModal>
                          <DataSetGoalsQuantityTextModal>
                            {`${goal.meta || 0} vendas`}
                            <IconGarbageContainer
                              onClick={() => deleteDailyGoal(goal.dia)}
                            >
                              <IconProducer src={garbage} cursor="pointer" />
                            </IconGarbageContainer>
                          </DataSetGoalsQuantityTextModal>
                        </DataSetGoalsQuantityContainerModal>
                      ))}
                    </MessageAddOrEditGoalContainer>
                  ) : (
                    <>
                      {isEditingGoal ? (
                        <ModalButtonsContainer>
                          <ButtonAddAndInputModalContainer>
                            <SetGoalsModalInput
                              onInput={HandlerDailyGoals}
                              placeholder="Insira sua meta aqui"
                              value={message}
                            />
                          </ButtonAddAndInputModalContainer>
                          <ButtonModalContainer>
                            <DashboardhMediumButton
                              onClick={onRequestClose}
                              variant="outlined"
                              borderRadius='100px'
                            >
                              Cancelar
                            </DashboardhMediumButton>
                            <CustomButton
                              background={
                                isLoading
                                  ? '#AAAAAA'
                                  : isSaveButtonDisabled
                                    ? getDashColor('SECONDARY_GREEN_06', 'PURPLE_DARK')
                                    : getDashColor('SECONDARY_GREEN_07', 'SECONDARY_COLOR')
                              }
                              color="#fff"
                              height="52px"
                              width="337px"
                              fontSize="16px"
                              fontWeight="500"
                              onClick={handleUpdateNewDailyGoal}
                              hover={getDashColor('SECONDARY_GREEN_06', 'PURPLE_DARK')}
                              disabled={isSaveButtonDisabled || isLoading}
                              borderRadius='100px'
                            >
                              {isLoading ? <LoadingSpinner /> : 'Salvar Meta'}
                            </CustomButton>
                          </ButtonModalContainer>
                        </ModalButtonsContainer>
                      ) : (
                        <MessageAddOrEditGoalContainer>
                          <MessageAddOrEditGoalText>
                            <IconProducer src={exclamationMark} />
                            Selecione um dia para adicionar ou editar a meta de
                            venda.
                          </MessageAddOrEditGoalText>
                        </MessageAddOrEditGoalContainer>
                      )}
                    </>
                  )}
                </ModalSetGoalsContainer>
              </CustomModal>
            </MainDailyGoalsContainer>
          </ConditionalRenderComponent>
        </DefaultCardDashboard>
      </ContainerCard>
    </Container>
  )
}

export default ManagerGoalsCard
